import syngentaDigitalLogo from 'assets/images/syngenta_logo.svg';
import React from 'react';
import { withRouter } from 'react-router-dom';
import ProtectorAppsStores from '../../components/ProtectorAppsStores';
import { ProtectorChoosePlan } from '../../components/ProtectorChoosePlan';
import ProtectorWhatIsIt from '../../components/ProtectorWhatIsIt';
import './styles.less';

const ProtectorMarketingFooter: React.FC = () => {
  return (
          <>
              <footer className="protector-mkt__footer">
                  <img alt="" src={syngentaDigitalLogo} style={{ width: '173.72px', height: '68.71px' }}/>
              </footer>
          </>
  );
};

const ProtectorMarketing = () => {
  return (
        <main className="protector-mkt">
            <ProtectorWhatIsIt />
            <ProtectorChoosePlan />
            <ProtectorAppsStores />
            <ProtectorMarketingFooter />
        </main>
  );
};

export const ProtectorMarketingPage = withRouter(ProtectorMarketing);
